/* eslint-disable max-len */
const avFundOptions = [
  { value: 'Brown Alumni', label: 'Brown Alumni: Waterman Ventures' },
  { value: 'Columbia Alumni', label: 'Columbia Alumni: 116 Street Ventures' },
  { value: 'Cornell Alumni', label: 'Cornell Alumni: Triphammer Ventures' },
  { value: 'Dartmouth Alumni', label: 'Dartmouth Alumni: Green D Ventures' },
  { value: 'Harvard Alums', label: 'Harvard Alums: Yard Ventures' },
  { value: 'MIT Alumni', label: 'MIT Alumni: Castor Ventures' },
  { value: 'Northwestern Alumni', label: 'Northwestern Alumni: Purple Arch Ventures' },
  { value: 'Penn Alumni', label: 'Penn Alumni: Chestnut Street Ventures' },
  { value: 'Princeton Alumni', label: 'Princeton Alumni: Nassau Street Ventures' },
  { value: 'Stanford Alumni', label: 'Stanford Alumni: Spike Ventures' },
  { value: 'Texas A&M Former Students', label: 'Texas A&M Former Students: Ring Ventures' },
  { value: 'U Chicago Alumni', label: 'U Chicago Alumni: Lakeshore Ventures' },
  { value: 'UC Berkeley Alumni', label: 'UC Berkeley Alumni: Strawberry Creek Ventures' },
  { value: 'University of Michigan Alumni', label: 'University of Michigan Alumni: Arbor Street Ventures' },
  { value: 'University of Texas Alumni', label: 'University of Texas Alumni: Congress Avenue Ventures' },
  { value: 'US Strategic Tech', label: 'US Strategic Tech' },
  { value: 'Wisconsin Alumni', label: 'Wisconsin Alumni: Bascom Ventures' },
  { value: 'Yale Alumni', label: 'Yale Alumni: Blue Ivy Ventures' },
  { value: 'AI & Robotics Fund', label: 'AI & Robotics Fund' },
  { value: 'Blockchain & Fintech Fund', label: 'Blockchain & Fintech Fund' },
  { value: 'CIO Select Fund', label: 'CIO Select Fund' },
  { value: 'Deep Tech Fund', label: 'Deep Tech Fund' },
  { value: 'Foundation Fund', label: 'Foundation Fund' },
  { value: 'Healthtech Fund', label: 'Healthtech Fund' },
  { value: 'Seed Fund', label: 'Seed Fund' },
  { value: 'Womens Fund', label: 'Womens Fund' },
  { value: 'AI First Fund', label: 'AI First Fund' },
];

export default avFundOptions;
